export default "__VITE_ASSET__KCX0zRYJrYRhEJsotaZb_A__";